"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _tooltip = _interopRequireDefault(require("../../components/Tooltip/tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StepButton = function StepButton(_ref) {
  var children = _ref.children,
      href = _ref.href,
      onClick = _ref.onClick,
      name = _ref.name,
      hint = _ref.hint,
      visited = _ref.visited,
      props = _objectWithoutProperties(_ref, ["children", "href", "onClick", "name", "hint", "visited"]);

  var className = 'co-stepper__step-target';

  var onClickHandler = function onClickHandler(e) {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return visited ? _react.default.createElement(_tooltip.default, {
    text: hint,
    position: _tooltip.default.POSITION_LEFT_TOP,
    inverted: true
  }, _react.default.createElement("a", _extends({
    href: href,
    className: className,
    onClick: onClickHandler,
    "aria-label": name
  }, (0, _getNativeProps.default)(props)), children)) : _react.default.createElement("span", _extends({
    className: className,
    "aria-label": name
  }, (0, _getNativeProps.default)(props)), children);
};

var Step = function Step(_ref2) {
  var children = _ref2.children,
      id = _ref2.id,
      visited = _ref2.visited,
      active = _ref2.active,
      props = _objectWithoutProperties(_ref2, ["children", "id", "visited", "active"]);

  var progressClasses = ['co-stepper__step', {
    'co-stepper__step--visited': visited
  }];
  return _react.default.createElement(_styler.default, {
    classNames: progressClasses,
    modifiers: {
      active: active
    }
  }, function (classes) {
    return _react.default.createElement("li", {
      id: id,
      className: classes
    }, _react.default.createElement(StepButton, _extends({
      visited: visited
    }, props), children));
  });
};

StepButton.defaultProps = {
  href: '#'
};
Step.propTypes = {
  /** {---} One of: @@string@@ @@number@@ */
  children: (0, _airbnbPropTypes.or)([_propTypes.string, _propTypes.number]).isRequired,
  id: _propTypes.string,

  /** {string} Required if @@visited@@ is truthy. */
  name: _propTypes.string.isRequired,

  /** {string} Required if @@visited@@ is truthy. */
  hint: _propTypes.string.isRequired,

  /** Renders the step as an active (current step). */
  active: _propTypes.bool,

  /** Renders the step as visited. */
  visited: _propTypes.bool,

  /** {func} Required if @@visited@@ is truthy. */
  onClick: (0, _airbnbPropTypes.requiredBy)('visited', _propTypes.func),
  href: _propTypes.string
};
Step.displayName = 'Stepper.Step';
var _default = Step;
exports.default = _default;
Step.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Stepper.Step",
  "props": {
    "children": {
      "type": {
        "name": "custom",
        "raw": "or([string, number]).isRequired"
      },
      "required": false,
      "description": "{---} One of: @@string@@ @@number@@"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "{string} Required if @@visited@@ is truthy."
    },
    "hint": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "{string} Required if @@visited@@ is truthy."
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Renders the step as an active (current step)."
    },
    "visited": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Renders the step as visited."
    },
    "onClick": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('visited', func)"
      },
      "required": false,
      "description": "{func} Required if @@visited@@ is truthy."
    },
    "href": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};